import { render, staticRenderFns } from "./OsPanelCardItem.vue?vue&type=template&id=52cb0bd3&scoped=true&"
import script from "./OsPanelCardItem.vue?vue&type=script&lang=js&"
export * from "./OsPanelCardItem.vue?vue&type=script&lang=js&"
import style0 from "./OsPanelCardItem.vue?vue&type=style&index=0&id=52cb0bd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cb0bd3",
  null
  
)

export default component.exports